<template>
	<div>
		<a
		class="btn mb-2 mr-2"
		:class="getClassStr()"
		@click="field.value = !field.value"
		>
		{{ field.question }}
		</a>
		<div v-if="field.description" v-html="field.description"></div>
	</div>
</template>

<script>
export default {
	props: ['field', 'readonly'],
	methods: {
		getClassStr() {
			const classArr = [];
			if(this.field.value) {
				if(this.field.cssclass) {
					classArr.push(`btn-on ${this.field.cssclass}`);
				} else {
					classArr.push('btn-on');
				}
			} else {
				classArr.push('btn-off');
			}
			if(this.readonly) {
				classArr.push('disabled');
			}
			return classArr.join(' ');
		}
	}
};
</script>
